import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import React from 'react';

type EventType = 'COMPANY_UPDATE' | string;

type EventTypeLabelProps = {
    type: EventType;
};

const useStyles = makeStyles((theme) => ({
    base: {
        fontSize: 14,
        fontWeight: 400,
        color: '#6c757d',
        marginBottom: theme.spacing(1),
        position: 'relative',
        paddingLeft: '12px',
        '&::before': {
            content: '""',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
        },
    },
    update: {
        '&::before': { background: '#f59e0b' },
    },
    new: {
        '&::before': { background: '#408bdf' },
    },
}));

const EventTypeLabel: React.FC<EventTypeLabelProps> = ({ type }) => {
    const classes = useStyles();
    const isUpdate = type === 'COMPANY_UPDATE';
    return (
        <Typography className={`${classes.base} ${isUpdate ? classes.update : classes.new}`}>
            {isUpdate ? 'Company Update' : 'New deal'}
        </Typography>
    );
};

export default EventTypeLabel;
